




import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import config from "@/config"

function getLink(id: string, text: string) {
    return {url: `${config.IPR_BASE_URL}/pages/locationjumper.asp` + `?id=${encodeURIComponent(id)}`, text}
  }

  function getLinkCallback(entity: string) {
    return (fieldName: string, row: any): { url: string, text: string } => {
      switch (entity) {
        case "Region":
          return getLink(row.RegionID, row.RegionName)
        case "Site":
          return getLink(row.SiteID, row.SiteName)
        case "Building":
          return getLink(row.BuildingID, row.BuildingName)
        case "Floor":
          return getLink(row.FloorID, row.FloorName)
        case "Rooms":
          return {url: `${config.IPR_BASE_URL}/pages/rooms.aspx?id=${encodeURIComponent(row.FloorID)}&sortorder=2&pb=100&page=1`, text: row.Rooms}
        default:
          return {url: "", text: ""}
      }
    }
  }

  @Component({
    components: {
      DataGrid,
    },
  })
  export default class AuditAuditedRoomsStatusDrillDown extends Vue {
    @Prop() public args!: {
      locationId: number,
      userId: number,
    }
    public fields = [
      {name: 'RegionName', title: 'Region', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: getLinkCallback("Region")},
      {name: 'SiteName', title: 'Site', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: getLinkCallback("Site")},
      {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: getLinkCallback("Building")},
      {name: 'FloorName', title: 'Floor', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: getLinkCallback("Floor")},
      {name: 'Rooms', title: 'Rooms', dataType: DataType.Number, sort: 1, component: DataGridLink, callback: getLinkCallback("Rooms")},
    ]

    public getData(offset = 0, limit = 200) {
      return getStoredProcedure(
        "AnalyticsCenter", "widget_ClashingRoomsDrillDown",
        [this.args.locationId, this.args.userId], undefined, offset, limit)
    }
  }
